<!-- @bad TODO: Keyboard navigation-->
<ng-container *ngIf="texts$ | async as texts">
    <tui-hosted-dropdown
        *ngIf="fontStyleState$ | async as state"
        #format
        [content]="formatDropdown"
    >
        <button
            tuiIconButton
            type="button"
            size="s"
            icon="tuiIconFormatLarge"
            appearance="icon"
            tuiHintDirection="top-left"
            automation-id="toolbar__font-style-button"
            tuiHintDescribe
            [tuiHint]="texts.fontStyle"
            [pseudoActive]="format.open || state.bold || state.italic || state.underline || state.strike"
            [focusable]="format.open"
        ></button>
        <ng-template #formatDropdown>
            <div class="t-dropdown">
                <button
                    *ngIf="isEnabled(TuiEditorTool.Bold)"
                    tuiIconButton
                    type="button"
                    size="s"
                    icon="tuiIconBoldLarge"
                    appearance="icon"
                    class="t-option t-option_margin"
                    [tuiHint]="texts.bold"
                    [pseudoActive]="state.bold"
                    (click)="editor.toggleBold()"
                ></button>
                <button
                    *ngIf="isEnabled(TuiEditorTool.Italic)"
                    tuiIconButton
                    type="button"
                    size="s"
                    icon="tuiIconItalicLarge"
                    appearance="icon"
                    class="t-option t-option_margin"
                    [tuiHint]="texts.italic"
                    [pseudoActive]="state.italic"
                    (click)="editor.toggleItalic()"
                ></button>
                <button
                    *ngIf="isEnabled(TuiEditorTool.Underline)"
                    tuiIconButton
                    type="button"
                    size="s"
                    icon="tuiIconUnderlineLarge"
                    appearance="icon"
                    class="t-option t-option_margin"
                    [tuiHint]="texts.underline"
                    [pseudoActive]="state.underline"
                    (click)="editor.toggleUnderline()"
                ></button>
                <button
                    *ngIf="isEnabled(TuiEditorTool.Strikethrough)"
                    tuiIconButton
                    type="button"
                    size="s"
                    icon="tuiIconStrikeThroughLarge"
                    appearance="icon"
                    class="t-option t-option_margin"
                    [tuiHint]="texts.strikeThrough"
                    [pseudoActive]="state.strike"
                    (click)="editor.toggleStrike()"
                ></button>
            </div>
        </ng-template>
    </tui-hosted-dropdown>
</ng-container>
